module.exports = __webpack_public_path__ + "img/loader.961e6f85.gif";